import { Transform, Type } from 'class-transformer';
import {
	calendarDateTransformer,
	dateTransformer,
} from 'src/lib/utilities/api/class-transformer-types';
import { UserAddressModel } from '../../utility/utility-models/address.model';
import {
	InstituteRoleResponseModel,
	InstituteRoleResponseModel_ClassTransform_Type,
} from '../permission-manager/permission-user-roles.model';
import { StudentContactAttributes } from '../students/contacts/student-contact-options.model';
import {
	ContactFieldMetadata,
	ContactFieldPhoneModel,
	ContactFieldValueModel,
} from './contact-field.model';

export class UserDataProfileModel {
	profile_employee_id: string;
	profile_first_name: string;
	profile_last_name: string;
	profile_preferred_name: string;
	profile_maiden_name: string;
	profile_student_gender: string;
	profile_field_race: string;
	profile_field_ethnicity: string;
	profile_middle_name: string;
	profile_suffix: string;
	profile_city: string;
	profile_user_title: string;
	profile_about: string;
	profile_state: string;
	profile_intro_video: string;
	profile_pronunciation: string;
}

export function UserDataProfileModel_ClassTransform_Type() {
	return UserDataProfileModel;
}

export class UserDataContactAddressModel
	extends UserAddressModel
	implements ContactFieldMetadata
{
	type: string;
	prim: boolean;
	active: boolean;
	weight: number;
}

export class UserDataContactModel {
	phone?: ContactFieldPhoneModel[];
	physical_address?: UserDataContactAddressModel;
	mailing_address?: UserDataContactAddressModel;
	email?: ContactFieldValueModel[];
	ssoEmail?: ContactFieldValueModel[];
	messenger?: ContactFieldValueModel[];
}

export function UserDataContactModel_ClassTransform_Type() {
	return UserDataContactModel;
}

export class UserDataProgramEnrollmentModel {
	program_id: number;
	title: string;
	is_primary: boolean;
	is_active: boolean;
	is_administrator: boolean;
}

export function UserDataProgramEnrollmentModel_ClassTransform_Type() {
	return UserDataProgramEnrollmentModel;
}

export class UserDataGAModel {
	programs: string[];
	primary_program_id: number | null;
	@Type(UserDataProgramEnrollmentModel_ClassTransform_Type)
	program_enrollments: UserDataProgramEnrollmentModel[];
}

export function UserDataGAModel_ClassTransform_Type() {
	return UserDataGAModel;
}

export class UserDataStudentModel {
	@Transform(calendarDateTransformer)
	dob: Date;
	program: string;
}

export function UserDataStudentModel_ClassTransform_Type() {
	return UserDataStudentModel;
}

export class UserDataPersonalContactPhoneModel {
	phone: number;
	is_primary: boolean;
	sms_blocked: boolean;
	type: string;
	sms: boolean;
}

export function UserDataPersonalContactPhoneModel_ClassTransform_Type() {
	return UserDataPersonalContactPhoneModel;
}

export class UserDataPersonalContactModel {
	link_id: number;
	name: string;
	@Type(UserDataPersonalContactPhoneModel_ClassTransform_Type)
	phones: UserDataPersonalContactPhoneModel[];
	emails: string[];
	url: string;
	account_uid: number;
	attributes: StudentContactAttributes[];
	relationship: string;
}

export function UserDataPersonalContactModel_ClassTransform_Type() {
	return UserDataPersonalContactModel;
}

export class UserDataUserModel {
	theme: boolean | string;
	student_theme: boolean | string;
	mobile_theme: boolean | string;
	@Transform(dateTransformer)
	created: Date;
	roles: string[];
	@Type(InstituteRoleResponseModel_ClassTransform_Type)
	institute_roles: InstituteRoleResponseModel;
	password: boolean;
	@Transform(dateTransformer)
	last_online: Date;
	status: boolean;
	profile_picture: string;
	profile_picture_high_res: string;
	admin_type: string[];
	timezone: string;
	user_custom_blob: Record<string, unknown>;
}

export function UserDataUserModel_ClassTransform_Type() {
	return UserDataUserModel;
}

export class UserDataContactsModel {
	@Type(UserDataPersonalContactModel_ClassTransform_Type)
	personal: UserDataPersonalContactModel[];
}

export function UserDataContactsModel_ClassTransform_Type() {
	return UserDataContactsModel;
}

export class UserDataModel {
	@Type(UserDataUserModel_ClassTransform_Type)
	user: UserDataUserModel;
	@Type(UserDataProfileModel_ClassTransform_Type)
	profile: UserDataProfileModel;
	@Type(UserDataContactModel_ClassTransform_Type)
	contact_field: UserDataContactModel;
	@Type(UserDataStudentModel_ClassTransform_Type)
	student_data: UserDataStudentModel;
	@Type(UserDataContactsModel_ClassTransform_Type)
	contacts: UserDataContactsModel;
	@Type(UserDataGAModel_ClassTransform_Type)
	ga: UserDataGAModel;
}

export class UserTimezoneModel {
	institute_timezone: string;
	timezone: string;
}
